import React, { useState } from "react"
import { Link } from "gatsby"

export default props => {
  const [toggle, setToggle] = useState(props.open)
  return (
    <div className="panel-group">
      <div className="panel panel-default">
        <div className="panel-heading">
          <h4
            className="panel-title nav-header"
            data-toggle="collapse"
            data-target={`#collapse${props.target}`}
            aria-expanded
            onClick={() => setToggle(prevState => !prevState)}
          >
            {props.title}
            <span
              className={`pull-right glyphicon ${
                toggle ? "glyphicon-minus" : "glyphicon-plus"
              }`}
            />
          </h4>
        </div>
        <div
          id={`collapse${props.target}`}
          className={`panel-collapse collapse${props.open ? " in" : ""}`}
          aria-expanded={props.open}
        >
          <div className="list-group sub-list-group">
            {props.links.map(link => {
              if (link.children) {
                // const isUserApi =
                return (
                  <React.Fragment key={link.href}>
                    <a
                      key={link.href}
                      href={`#${link.href}`}
                      className={`list-group-item list-group-item-parent${
                        props.apiOpen.includes("/" + link.href + "/")
                          ? " active"
                          : ""
                      }`}
                      data-toggle="collapse"
                    >
                      {link.name}
                    </a>
                    <div
                      className={`panel-collapse collapse ${
                        props.apiOpen.includes("/" + link.href + "/")
                          ? " in"
                          : ""
                      }`}
                      id={link.href}
                    >
                      <div className="list-group">
                        {link.children.map(sublink => {
                          return (
                            <Link
                              key={sublink.href}
                              to={sublink.href}
                              className="list-group-item"
                              activeClassName="active"
                            >
                              {sublink.name}
                            </Link>
                          )
                        })}
                      </div>
                    </div>
                  </React.Fragment>
                )
              }
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  replace
                  className="list-group-item list-group-item-parent"
                  activeClassName="active"
                >
                  {link.name}
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
